/* Zeno: sticky Add to Cart bar + bottom sheet (markup/styles in snippets/sticky-atc.liquid).
   Self-contained variant matching and add-to-cart. Cart refresh uses the same
   section-request pattern as Dawn's cart-drawer.js (sections: cart-drawer,
   cart-icon-bubble, then cart-drawer.renderContents). The bar re-syncs to the
   main product form's selected variant every time it appears or the sheet opens,
   so it never shows a stale size.

   Also drives the one-off Add to Cart sheen (CSS in zeno-add-to-cart-caps.css):
   once when the main button first scrolls into view, and again after a
   size/colour is picked.
   Select a size: when the product page hasn't had a size picked (window.ZenoSizePick, set by zeno-pdp-extras.js),
   the sheet opens with no size chosen and the button reads "Select a size" until one is tapped. */
(function () {
  var ATC = 'Add to cart';
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD',
      }).format(cents / 100).replace(/\.00$/, '');
    } catch (e) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
  }

  function refreshCart(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      drawer.renderContents({ id: data.id, sections: data.sections });
      if (typeof drawer.open === 'function') drawer.open();
      return true;
    }
    return false;
  }

  function init(root) {
    var sectionId = root.getAttribute('data-section');
    var dataEl = root.parentElement.querySelector('[data-zeno-sticky-atc-product]') || document.querySelector('script[data-zeno-sticky-atc-product]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var multi = product.variants && product.variants.length > 1;
    var barBtn = root.querySelector('[data-zeno-sticky-atc-button]');
    var confirmBtn = root.querySelector('[data-zeno-sticky-atc-confirm]');
    var sheet = root.querySelector('[data-zeno-sticky-atc-sheet]');
    var backdrop = root.querySelector('[data-zeno-sticky-atc-backdrop]');
    var closeBtn = root.querySelector('[data-zeno-sticky-atc-close]');
    var sheetPrice = root.querySelector('[data-zeno-sticky-atc-sheet-price]');
    var variantText = root.querySelector('[data-zsa-variant]');
    var thumbs = root.querySelectorAll('[data-zsa-thumb]');
    var groups = root.querySelectorAll('[data-zeno-sticky-atc-option]');
    var sizeLink = root.querySelector('[data-zsa-size]');

    // Index of the Size option (only when there is more than one size), for "Select a size".
    var sizeIdx = -1;
    groups.forEach(function (g) {
      var lab = g.querySelector('.zsa__label');
      if (lab && /size/i.test(lab.textContent) && g.querySelectorAll('[data-zeno-sticky-atc-value]').length > 1) sizeIdx = parseInt(g.getAttribute('data-option-index'), 10);
    });
    function needSize() { return multi && sizeIdx > -1 && selected[sizeIdx] == null; }
    function nudge() {
      var g = root.querySelector('[data-zeno-sticky-atc-option][data-option-index="' + sizeIdx + '"]');
      if (!g) return;
      g.classList.remove('zn-shake');
      void g.offsetWidth;
      g.classList.add('zn-shake');
      setTimeout(function () { g.classList.remove('zn-shake'); }, 600);
    }

    var selected = [];
    groups.forEach(function (g) {
      var s = g.querySelector('.is-selected');
      selected.push(s ? s.getAttribute('data-zeno-sticky-atc-value') : null);
    });

    function current() {
      if (!multi) return product.variants[0];
      return product.variants.filter(function (v) {
        var o = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) { return val === null || o[i] === val; });
      })[0] || null;
    }

    function markPills() {
      groups.forEach(function (g) {
        var i = parseInt(g.getAttribute('data-option-index'), 10);
        g.querySelectorAll('[data-zeno-sticky-atc-value]').forEach(function (p) {
          p.classList.toggle('is-selected', p.getAttribute('data-zeno-sticky-atc-value') === selected[i]);
        });
        var val = g.querySelector('[data-zsa-val]');
        if (val) val.textContent = selected[i] || '';
      });
    }

    function updateUI() {
      var v = current(), pick = needSize();
      var price = v ? formatMoney(v.price) : '';
      var label = pick ? 'Select a size' : !v ? 'Unavailable' : !v.available ? 'Sold out' : ATC + ' · ' + price;
      [barBtn, confirmBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = pick ? false : (!v || !v.available);
        b.textContent = label;
      });
      if (sheetPrice) sheetPrice.textContent = price;
      if (variantText && v) variantText.textContent = v.title.split(' / ').join(' · ');
      if (v && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src;
        thumbs.forEach(function (t) { t.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200'; });
      }
    }

    function syncFromMain() {
      if (!multi) return;
      var info = document.getElementById('ProductInfo-' + sectionId);
      var input = (info && info.querySelector('form input[name="id"]')) || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (!input || !input.value) return;
      var v = product.variants.filter(function (x) { return String(x.id) === String(input.value); })[0];
      if (!v) return;
      selected = [v.option1, v.option2, v.option3].slice(0, groups.length);
      // The product page hasn't had a size picked yet, so the sheet starts without one too.
      if (sizeIdx > -1 && window.ZenoSizePick && !window.ZenoSizePick.picked) selected[sizeIdx] = null;
      markPills();
      updateUI();
    }

    groups.forEach(function (g) {
      var i = parseInt(g.getAttribute('data-option-index'), 10);
      g.querySelectorAll('[data-zeno-sticky-atc-value]').forEach(function (p) {
        p.addEventListener('click', function () {
          selected[i] = p.getAttribute('data-zeno-sticky-atc-value');
          markPills();
          updateUI();
        });
      });
    });

    function openSheet() {
      syncFromMain();
      document.body.classList.add('zsa-lock');
      sheet.hidden = false;
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        sheet.classList.add('is-open');
        backdrop.classList.add('is-open');
      });
    }

    function closeSheet() {
      document.body.classList.remove('zsa-lock');
      sheet.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      setTimeout(function () { sheet.hidden = true; backdrop.hidden = true; }, 250);
    }

    function addToCart(btn) {
      if (needSize()) { nudge(); return; }
      var v = current();
      if (!v || !v.available) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.disabled = false;
          btn.textContent = label;
          if (data.status) return;
          closeSheet();
          if (!refreshCart(data)) window.location.href = '/cart';
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    }

    if (barBtn) barBtn.addEventListener('click', function () { if (multi) openSheet(); else addToCart(barBtn); });
    if (confirmBtn) confirmBtn.addEventListener('click', function () { addToCart(confirmBtn); });
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (backdrop) backdrop.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });

    if (sizeLink) {
      var advisorBtn = document.querySelector('[data-zn-size] [data-fit-open]');
      if (advisorBtn) {
        sizeLink.hidden = false;
        sizeLink.addEventListener('click', function () {
          closeSheet();
          setTimeout(function () { advisorBtn.click(); }, 260);
        });
      }
    }

    updateUI();

    var info = document.getElementById('ProductInfo-' + sectionId);
    if (info && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (past && root.hidden) syncFromMain();
        root.hidden = !past;
        if (!past && !sheet.hidden) closeSheet();
      }, { threshold: 0 }).observe(info);
    }

    initSheen(info || document);
  }

  /* One-off Add to Cart sheen */
  function initSheen(scope) {
    function button() {
      return scope.querySelector('.product-form__submit.button--primary');
    }
    function sheen() {
      var b = button();
      if (!b || b.disabled) return;
      b.classList.remove('zn-sheen');
      void b.offsetWidth;
      b.classList.add('zn-sheen');
      setTimeout(function () { b.classList.remove('zn-sheen'); }, 1300);
    }
    var first = button();
    if (first && window.IntersectionObserver) {
      var seen = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          seen.disconnect();
          setTimeout(sheen, 400);
        }
      }, { threshold: 0.9 });
      seen.observe(first);
    }
    var timer;
    scope.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects')) return;
      clearTimeout(timer);
      timer = setTimeout(sheen, 450);
    });
  }

  function initAll() { document.querySelectorAll('[data-zeno-sticky-atc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
})();
